var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7091 10.3087L12.4364 4.19963C12.1455 3.90872 11.7091 3.90872 11.5636 4.19963L4.29091 10.3087C4.14545 10.4542 4 10.7451 4 10.8905V19.1814C4 19.6178 4.29091 19.9087 4.72727 19.9087H19.2727C19.7091 19.9087 20 19.6178 20 19.1814V10.8905C20 10.7451 19.8545 10.4542 19.7091 10.3087ZM14.0364 18.5996H9.96364V15.2542C9.96364 14.0905 10.8364 13.2178 12 13.2178C13.1636 13.2178 14.0364 14.0905 14.0364 15.2542V18.5996Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.9c563731b72be093de321043eb71c2ca.svg";
export { ForwardRef as ReactComponent };